import { Link } from 'react-router-dom';

const JoinUs = () => {
  return (
    <section id="join-us" className="py-20 md:py-28">
      <div className="container mx-auto px-6 max-w-5xl">
        <div className="text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-teal-700">You Can Make a Difference</h2>
          <p className="mt-4 text-lg text-stone-600 max-w-3xl mx-auto">Every contribution, big or small, helps us build a future where everyone has access to the medical and dental care they deserve. Join our mission today.</p>
        </div>
        <div className="mt-12 grid md:grid-cols-3 gap-8 text-center">
          <div className="bg-white p-8 rounded-2xl shadow-lg border border-stone-200 flex flex-col">
            <h3 className="text-2xl font-bold text-teal-800">Donate</h3>
            <p className="mt-2 text-stone-600 flex-grow">Your financial support funds our training programs, mobile clinics, and educational materials. A small gift can provide life-changing care.</p>
            <Link to="/donate" className="mt-6 bg-teal-600 text-white w-full px-6 py-3 rounded-lg font-semibold hover:bg-teal-700 transition-colors shadow">Give Today</Link >
          </div>
          <div className="bg-white p-8 rounded-2xl shadow-lg border border-stone-200 flex flex-col">
            <h3 className="text-2xl font-bold text-teal-800">Volunteer</h3>
            <p className="mt-2 text-stone-600 flex-grow">Lend your time and skills. We need medical professionals, educators, and administrative support to expand our reach.</p>
            <a href="/volunteer" className="mt-6 bg-stone-200 text-stone-700 w-full px-6 py-3 rounded-lg font-semibold hover:bg-stone-300 transition-colors inline-block">Learn More</a>
          </div>
          <div className="bg-white p-8 rounded-2xl shadow-lg border border-stone-200 flex flex-col">
            <h3 className="text-2xl font-bold text-teal-800">Partner</h3>
            <p className="mt-2 text-stone-600 flex-grow">Collaborate with us. We partner with corporations, NGOs, and community leaders to create a greater impact together.</p>
            <Link to="/contact" className="mt-6 bg-stone-200 text-stone-700 w-full px-6 py-3 rounded-lg font-semibold hover:bg-stone-300 transition-colors text-center block">Contact Us</Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JoinUs;